/**
 * O escopo da ficha aberta, estável entre desenhos.
 *
 * POR QUE NÃO `escopoDaFicha(ficha)` DIRETO: a moldura pode recriar o objeto `ficha` a cada
 * desenho, com os mesmos valores. Um escopo novo a cada desenho dispararia de novo toda leitura
 * que depende dele, e a aba ficaria relendo o banco sem parar. Aqui ele só muda quando muda a
 * cliente ou o lead, que são as duas coisas que o `comEscopo` do legado usa (`admin.html:3320`).
 */

// Memória do React.
import { useMemo } from 'react';
// O tipo do escopo que o pacote de dados recebe.
import type { Escopo } from '@studiolu/dados';
// O contrato da ficha.
import type { FichaAberta } from '../../comum-ficha/tipos.js';

export function useEscopoEstavel(ficha: FichaAberta): Escopo {
  // Os dois valores que definem o escopo, lidos como `escopoDaFicha` os lê.
  const userId = ficha.cliente.user_id;
  const leadId = ficha.lead?.id ?? null;
  // Um objeto novo só quando um dos dois muda.
  return useMemo(() => ({ userId, leadId }), [userId, leadId]);
}
